<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left"></div>
        <div class="header-right">
          <div>
            <span>名字：</span>
            <el-input
              v-model="userName"
              size="small"
              placeholder="请输入用户ID"
            ></el-input>
          </div>
          <div>
            <span>手机号：</span>
            <el-input
              v-model="userPhone"
              size="small"
              placeholder="请输入用户手机号"
            ></el-input>
          </div>
          <div>
            <span>状态：</span>
            <el-select
              v-model="status"
              size="small"
              placeholder="请选择申请状态"
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <el-button type="primary" size="small" @click="searchApplication"
            >查询</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="applicationList" style="width: 100%;">
            <el-table-column label="手机号" align="left" width="200">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.phone }}</div>
              </template>
            </el-table-column>
            <el-table-column label="申请信息" align="center" width="300">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.content }}</div>
              </template>
            </el-table-column>
            <el-table-column label="申请时间" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.createTime }}</div>
              </template>
            </el-table-column>
            <el-table-column label="姓名" align="center" width="200">
              <template slot-scope="scope">
                <div class="name">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <div
                  class="status"
                  :class="{
                    suc: scope.row.status == 2,
                    ing: scope.row.status == 1,
                    fail: scope.row.status == 3,
                  }"
                >
                  {{ statusObj[scope.row.status] }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div v-show="scope.row.status == 1">
                  <el-button
                    type="success"
                    size="small"
                    @click="actionApplication(scope.$index, 2)"
                    >通过</el-button
                  >
                  <el-button
                    type="danger"
                    size="small"
                    @click="actionApplication(scope.$index, 3)"
                    >拒绝</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getApplicationList, updateApplicationApply } from "@/api/index.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      statusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待处理",
          value: 1,
        },
        {
          label: "通过",
          value: 2,
        },
        {
          label: "拒绝",
          value: 3,
        },
      ],
      statusObj: {
        1: "待处理",
        2: "通过",
        3: "拒绝",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      applicationList: [],
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      status: "",
      userName: "",
      userPhone: "",
      time: "",
      startTime: "",
      endTime: "",
      currentStatus: "",
      currentMallOrderId: "",
      currentStartTime: "",
      currentEndTime: "",
    };
  },
  watch: {
    time(val) {
      console.log(val);
      if (val) {
        this.startTime = new Date(val[0]).pattern("yyyy-MM-dd");
        this.endTime = new Date(val[1]).pattern("yyyy-MM-dd");
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getApplicationList();
    },
    getApplicationList() {
      getApplicationList({
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
        status: this.status,
        name: this.userName,
        phone: this.userPhone,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data.totalCount;
          this.applicationList = res.data.list;
        }
        if (res.code == -1) {
          this.applicationList = [];
        }
      });
    },
    searchApplication() {
      this.currentStatus = this.status;
      this.currentMallOrderId = this.mallOrderId;
      this.currentStartTime = this.startTime;
      this.currentEndTime = this.endTime;
      this.getPageData();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getApplicationList();
    },
    actionApplication(index, status) {
      updateApplicationApply({
        messageId: this.applicationList[index].id,
        status,
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.applicationList[index].status = status;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-left {
    height: 30px;
    align-items: center;
    & > div {
      margin-left: 20px;
    }
  }
  .header-right {
    & > div {
      .el-input {
        display: inline-block;
        width: 130px;
      }
    }
    & > div + div {
      margin-left: 10px;
    }
    .el-button {
      margin-left: 10px;
    }
  }
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
      cursor: pointer;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
